/**
 *  @class
 *  @function MediaGridSection
 */

if (!customElements.get('media-grid-section')) {
  class MediaGridSection extends HTMLElement {
    constructor() {
      super();

      this.tl = false;
      this.hoverTimelines = [];
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      if (this.animations_enabled) {
        this.prepareAnimations();
        this.prepareHoverAnimations();
      }
    }
    disconnectedCallback() {
      if (this.animations_enabled) {
        if (this.tl) {
          this.tl.kill();
        }
        this.hoverTimelines.forEach((tl) => tl.kill());
      }
    }
    prepareAnimations() {
      let section = this,
        items = section.querySelectorAll('.media-grid--item');

      section.tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "top 70%"
        }
      });

      items.forEach((item, index) => {
        let subheading = item.querySelector('.subheading'),
          heading = item.querySelector('.media-grid--content h2, .media-grid--content h3, .media-grid--content h4'),
          button = item.querySelector('.text-button'),
          offset = index * 0.15;

        // Animate the whole item in
        section.tl.fromTo(item, {
          opacity: 0,
          y: 40
        }, {
          duration: 0.8,
          opacity: 1,
          y: 0,
          ease: 'power4.out'
        }, offset);

        // Stagger content elements within each item
        if (subheading) {
          section.tl.fromTo(subheading, {
            opacity: 0,
            y: 20
          }, {
            duration: 0.6,
            opacity: 1,
            y: 0,
            ease: 'power3.out'
          }, offset + 0.2);
        }

        if (heading) {
          section.tl.fromTo(heading, {
            opacity: 0,
            y: 25
          }, {
            duration: 0.7,
            opacity: 1,
            y: 0,
            ease: 'power3.out'
          }, offset + 0.3);
        }

        if (button) {
          section.tl.fromTo(button, {
            opacity: 0,
            y: 15
          }, {
            duration: 0.5,
            opacity: 1,
            y: 0,
            ease: 'power3.out'
          }, offset + 0.5);
        }
      });
    }
    prepareHoverAnimations() {
      let items = this.querySelectorAll('.media-grid--item');

      items.forEach((item) => {
        let bg = item.querySelector('.media-grid--bg img, .media-grid--bg video'),
          overlay = item.querySelector('.media-grid--bg'),
          content = item.querySelector('.media-grid--content');

        if (!bg && !content) return;

        let hoverTl = gsap.timeline({ paused: true });

        if (bg) {
          hoverTl.to(bg, {
            duration: 0.6,
            scale: 1.05,
            ease: 'power2.out'
          }, 0);
        }

        // Darken overlay slightly on hover
        hoverTl.to(item, {
          duration: 0.4,
          '--overlay-opacity': function() {
            let current = parseFloat(getComputedStyle(item).getPropertyValue('--overlay-opacity')) || 0;
            return Math.min(current + 0.12, 0.5);
          },
          ease: 'power2.out'
        }, 0);

        if (content) {
          hoverTl.to(content, {
            duration: 0.4,
            y: -5,
            ease: 'power2.out'
          }, 0);
        }

        item.addEventListener('mouseenter', () => hoverTl.play());
        item.addEventListener('mouseleave', () => hoverTl.reverse());

        this.hoverTimelines.push(hoverTl);
      });
    }
  }
  customElements.define('media-grid-section', MediaGridSection);
}
